<template>
  <ValidationObserver ref="form" v-slot="{ handleSubmit, errors }">
    <article class="filter-container mt-2" v-if="showContainer">
      <div class="row" v-if="!isIndividual">
        <div class="col-12 col-md-4">
          <ValidationProvider
            name="searchInput"
            rules="required"
            mode="passive"
          >
            <CustomInput
              v-model="searchField"
              data-vv-validate-on="change"
              placeholder="Escriba nombre del estudiante o número de SIE"
              icon="fa fa-search orange-icon"
              left-icon
            />
          </ValidationProvider>
        </div>
        <div :class="['col-12 mt-2 mt-md-0 col-md-5']">
          <ActionButton
            type="button"
            text="Buscar"
            variant="success"
            i="fas fa-search"
            class="mr-2"
            :responsive="isMobile"
            @click="handleSubmit(submitSearch)"
          />
          <ActionButton
            v-if="showCancelButton"
            text="Cancelar"
            variant="danger"
            class="mr-2"
            i="fas fa-times-circle"
            :responsive="isMobile"
            @click="cancel"
          />
          <ActionButton
            v-if="showAddStudentButton"
            text="Añadir Estudiante"
            variant="outline-success"
            i="fas fa-user-plus"
            :responsive="isMobile"
            @click="$emit('show-add-student', true)"
          />
        </div>
        <div class="col-12 col-md-3 mt-2 text-md-right">
          {{ textCount }}
          <span class="text-orange">
            {{ studentCount }}
          </span>
        </div>
      </div>
      <div class="row" v-if="isIndividual">
        <div class="col-12 text-right">
          <ActionButton
            v-if="showAddStudentButton"
            text="Añadir Estudiante"
            variant="outline-success"
            i="fas fa-user-plus"
            :responsive="isMobile"
            @click="$emit('show-add-student', true)"
          />
        </div>
      </div>
    </article>
    <slot />
    <CustomError
      v-if="errors.searchInput && errors.searchInput.length"
      variant="no-border"
      message="Favor escriba el nombre o número de SIE del estudiante para obtener resultados de la búsqueda."
      class="mt-1"
    />
  </ValidationObserver>
</template>

<script>
import CustomInput from "CustomInput";
import ActionButton from "ActionButton";
import CustomError from "custom-error";

export default {
  name: "StudentsHeaderFilter",
  components: {
    CustomInput,
    ActionButton,
    CustomError
  },
  props: {
    studentCount: {
      type: Number,
      default: 0
    },
    showAddStudentButton: {
      type: Boolean,
      default: true
    },
    isIndividual: {
      type: Boolean,
      default: true
    },
    textCount: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      showCancelButton: false,
      searchField: null
    };
  },
  computed: {
    showContainer() {
      return (
        (this.isIndividual &&
          this.studentCount == 0 &&
          this.showAddStudentButton) ||
        !this.isIndividual
      );
    },
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    }
  },
  methods: {
    submitSearch() {
      this.$emit("on-search", this.searchField);
      this.showCancelButton = true;
    },
    cancel() {
      this.searchField = null;
      this.$emit("on-search", this.searchField);
      this.showCancelButton = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@use "sass:map";
@import "@/assets/scss/variables/_colors.scss";

.filter-container {
  background-color: $gray;
  padding: 15px;
  border-radius: 5px;
}
</style>
